import classNames from "classnames";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";

import { TrashIcon } from "../../AscIcons";

import styles from "./AscPuzzleQuestionAnswerForm.module.scss";
import { AdminCrosswordProps } from "@ascendnow/shared";
import { If } from "react-conditional-components-renderer";

export interface AscPuzzleQuestionAnswerFormProps {
  className?: string;
  onChange: (value: Partial<AdminCrosswordProps>) => void;
  value: Partial<AdminCrosswordProps>;
  onDelete?: () => void;
  canDelete?: boolean;
  type?: "crossword" | "findWord";
}

export default function AscPuzzleQuestionAnswerForm({
  className,
  onChange,
  onDelete,
  canDelete = false,
  value,
  type = "crossword",
}: AscPuzzleQuestionAnswerFormProps) {
  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <If test={type === "crossword"}>
          <div className={styles.formField}>
            <label className={styles.fieldLabel} htmlFor="cellNumber">
              No
            </label>
            <div className={styles.inputField}>
              <AscTextInput
                type="number"
                min={0}
                step={1}
                fullWidth={true}
                placeholder="Cell number"
                value={value?.beginningCellNumber || ""}
                onChange={(e) =>
                  onChange?.({ beginningCellNumber: Number(e?.target?.value) })
                }
              />
            </div>
          </div>
        </If>

        <div className={classNames(styles.formField, styles.questionField)}>
          <label className={styles.fieldLabel} htmlFor="question">
            Question
          </label>
          <div className={classNames(styles.inputField)}>
            <AscTextInput
              className={styles.input}
              fullWidth={true}
              placeholder="Enter question"
              value={value?.question}
              onChange={(e) =>
                onChange?.({ question: e?.target?.value })
              }
            />
          </div>
        </div>

        <div className={styles.formField}>
          <label className={styles.fieldLabel} htmlFor="answer">
            Answer
          </label>
          <div className={styles.inputField}>
            <AscTextInput
              fullWidth={true}
              placeholder={"Enter answer"}
              value={value?.answer}
              onChange={(e) =>
                onChange?.({ answer: e?.target?.value })
              }
            />

            <hr className={styles.hR} />

            <TrashIcon
              onClick={canDelete ? onDelete : undefined}
              className={classNames(styles.trashIcon, {
                [styles.iconDisabled]: !canDelete,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
